import {errorMessage} from 'shared/actions/notifications';
import strings from 'student-search/strings.json';

// until we figure out how to type redux dispatch, disabling this check

export const collegePortalErrorMessage = (): ((dispatch: $TSFixMe) => void) =>
  errorMessage(strings.errors.collegePortalErrorMessage);
